import { useMemo } from 'preact/hooks'
import { usePagination } from 'hooks/usePagination'
import { pagination, goToPage, isLoading } from 'snippets/plp-native/@store'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import ProgressBar from 'snippets/progress-bar/progress-bar'

function PlpNativePagination({ filterType }) {
  if (!pagination.value) return null

  const { currentPage, totalProducts, perPage } = pagination.value

  if (currentPage === 0 || totalProducts === 0) return null

  const paginationRange = usePagination({ totalCount: totalProducts, pageSize: perPage, siblingCount: 1, currentPage })

  const onNext = () => {
    goToPage([currentPage + 1], filterType)
  }

  const lastPage = paginationRange[paginationRange.length - 1]
  const currentTotalProducts = perPage * currentPage > totalProducts ? totalProducts : perPage * currentPage

  const styles = useMemo(() => {
    const percent = currentTotalProducts ? Math.min(currentTotalProducts / totalProducts, 1) : 0

    return { transform: `scaleX(${percent})` }
  }, [currentTotalProducts])

  return (
    <div className="mt-4 pb-4 block text-center lg:pb-10 lg:mt-10" aria-label={translate.collection.pagination}>
      <div className="text-xs text-neutral-900">
        You’ve viewed {currentTotalProducts} of {totalProducts}{' '}
        {filterType === 'product' && (totalProducts > 1 ? 'products' : 'product')}
      </div>
      {currentPage !== lastPage && (
        <>
          <ProgressBar
            customStyles={styles}
            className="relative mx-auto mb-6 mt-3 h-0.5 w-full max-w-[232px] bg-neutral-200 md:mt-4 md:max-w-[317px]"
          />
          <button
            type="button"
            className={`button-outlined ${isLoading.value ? 'mx-auto' : ''}`}
            disabled={isLoading.value}
            aria-label="Load more products"
            onClick={onNext}
          >
            {isLoading.value ? <LoaderSpin size={4} /> : `Load more${filterType === 'product' ? ' products' : ''}`}
          </button>
        </>
      )}
    </div>
  )
}

export default PlpNativePagination
